import * as R from 'ramda'
import config from '../src/config'


export const getLinesById = (state, id, index) => {
    let line = R.prop(id, state.lines)
    line.id = id;
    line.indexLine = index;
    return line
}

export const getTagsById = (state, id) => {
    let tag = R.prop(id, state.tags);
    tag.id = id;
    return tag
}



export const getLines = state => {
    const applyFilter = item => {
        if(!state.filterTagIds.length){
            return true
        }
        let arr = R.intersection(item.tags ? item.tags : [], state.filterTagIds)

        return  arr.length ? true : false
    };

    const applySearchQuery = item => {
        if(!state.settings.searchLine){
            return true
        }


        if(item.text.trim().toLowerCase().indexOf(state.settings.searchLine.trim().toLowerCase()) + 1){
            return true
        }else {
            return false
        }

    };

    let mapIndexed = R.addIndex(R.map);

    let lines = R.compose(
        R.filter(applyFilter),
        R.filter(applySearchQuery),
        mapIndexed((id, index) => getLinesById(state, id, index)),
    )(state.linesIds)


    return lines
}


export const getTags = state => {
    const tags = R.compose(
        R.map(id => getTagsById(state, id))
    )(state.tagsIds)

    return tags
}

export const getKeyLineByIndex = (linesIds, index) => linesIds[index]

export const getKeyTagByIndex = (tagsIds, index) => tagsIds[index]

export const snapshotToArray = snapshot => {
    var returnArr = [];
    snapshot && Object.keys(snapshot).forEach(function(childSnapshot) {
        var item = snapshot[childSnapshot];
        //item.key = childSnapshot;
        returnArr.push(item);
    });

    return returnArr;
};

export const objToArray = snapshot => {

    var returnArr = Object.keys(snapshot).map(key =>  snapshot[key]);

    return returnArr;
};

export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export const getArrForLightBox = arr => {
    let tempArr = [];
    arr && objToArray(arr).map((item) => {
         let img =  {
             src: config.storageUrl + item.title + '?alt=media&token=' + config.token,
             thumbnail: config.storageUrl + item.title + '?alt=media&token=' + config.token
         }
         tempArr.push(img)
     })
    return tempArr
}

export const getSumSavedNotification = (data) => {
    let sum = 0;
    objToArray(data).forEach(item => {
        sum += item.countHistory
    })

    return sum
}


// WEBPACK FOOTER //
// ./src/selectors.js